import $ from 'jquery';
console.log('[utility] loaded. Jquery:' + $.fn.jquery);
function getAbsolutePath(relativePath) {
    return window.location.origin + relativePath;
}
function isNullOrEmpty(value) {
    if (value === undefined || value === '' || value === null || value.trim() === '') {
        return true;
    }
    return false;
}
function getSafeRouteByResolvingIdField(urlRoute, id) {
    return urlRoute.replace('{Id}', id);
}

function isFileTypeAllowed(fileControl) {
    console.log('Uploading file' + fileControl);
    try {
        if (/\.(jpe?g|png)$/i.test(fileControl.files[0].name) === false) {
            return false;
        }
    } catch (err) {
        console.log('[isFileTypeAllowed]');
        console.log(err);
        return false;
    }
    return true;
}

function isFileSizeValid(fileControl) {
    try {
        let fileSize = fileControl.files[0].size / 1024 / 1024; // in MiB
        if (fileSize > 1) {
            return false;
        }
    } catch (err) {
        console.log('[isFileSizeValid]');
        console.log(err);
        return false;
    }
    return true;
}

function isFormValid(formElement, shouldReport) {
    let requiredFields = [];
    let requiredElements = $(formElement).find(
        'input[data-required="true"],select[data-required="true"]'
    );
    console.log('[requiredElements]' + requiredElements.length);
    clearValidationErrors();
    if (requiredElements.length > 0) {
        $(requiredElements).each(function (index) {
            let value = $(this).val();
            if (isNullOrEmpty(value)) {
                let fieldId = $(this).attr('id');
                requiredFields.push(fieldId);
                highlightValidationError(fieldId);
            }
            console.log('[isFormValid]' + $(this).attr('id') + ': ' + $(this).val());
        });
    }
    if (requiredFields.length > 0) {
        console.log('[requiredFields[0]]' + requiredFields[0]);
        document.getElementById(requiredFields[0]).focus();
        return false;
    }
    return true;
}
function clearValidationErrors() {
    $('.field-validation-error').each(function (index) {
        $(this).html('');
        $(this).removeClass('field-validation-error').addClass('field-validation-valid');
    });
}
function highlightValidationError(fieldId, validationMessage) {
    let message = '* required';
    if (validationMessage && validationMessage.length > 0) {
        message = validationMessage;
    }
    let span = $('<span/>').html(message);
    let validationElement = $('span[data-valmsg-for="' + fieldId + '"]');
    console.log('validationElement' + validationElement);
    if (!(validationElement && validationElement.length > 0)) {
        // try finding element with id replaced underscore to dot
        if (fieldId.indexOf('_') > 0) {
            let fieldIdWithDot = fieldId.replace('_', '.');
            validationElement = $('span[data-valmsg-for="' + fieldIdWithDot + '"]');
        }
    }
    $(validationElement).removeClass('field-validation-valid').addClass('field-validation-error');
    $(validationElement).html(span);
}
function showConfirmationModal(title, bodyText) {
    if (title && bodyText) {
        let titleElement = $('#basicConfirmationModal .modal-title');
        $(titleElement).html(title);
        let bodyElement = $('#basicConfirmationModal .modal-body-text');
        $(bodyElement).html(bodyText);
        $('#basicConfirmationModal').modal('show');
    }
}
function isMobileDevice() {
    if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
    ) {
        return true;
    }
    return false;
}

function isImpressionTracked(element) {
    if (element && element.dataset && !!element.dataset.impressionTracked) {
        return true;
    }
    return false;
}
function setImpressionTracked(element) {
    if (element) {
        element.dataset.impressionTracked = true;
    }
}
export {
    getAbsolutePath,
    isNullOrEmpty,
    getSafeRouteByResolvingIdField,
    isFileTypeAllowed,
    isFileSizeValid,
    isFormValid,
    clearValidationErrors,
    highlightValidationError,
    showConfirmationModal,
    isMobileDevice,
    isImpressionTracked,
    setImpressionTracked,
};
